import { Link } from 'react-router-dom';
import { useState, useEffect, useRef } from "react";
export default function AGPodcastsSection() {
  const ref = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const obs = new IntersectionObserver(([e]) => {
      if (e.isIntersecting) setVisible(true);
    }, {
      threshold: 0.1
    });
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);
  return <section style={{
    backgroundColor: "#F5F4F2"
  }} className="w-full py-12 md:py-20 overflow-hidden">
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Oswald:wght@400;500;600&family=Inter:wght@300;400;500;600&display=swap');
        
        .podcasts-btn {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          color: #ffffff;
          font-family: 'Inter', sans-serif;
          font-size: 14px;
          font-weight: 500;
          line-height: 21px;
          background-color: rgb(53, 53, 51);
          border-radius: 28px;
          border: 1px solid rgb(53, 53, 51);
          padding: 4px 4px 4px 12px;
          text-transform: uppercase;
          text-decoration: none;
          cursor: pointer;
          transition: background-color 0.15s ease, border-color 0.15s ease, color 0.15s ease;
        }
        .podcasts-btn:hover {
          background-color: #424649;
          border-color: #373b3e;
          color: #ffffff;
        }
        .podcasts-btn-icon {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          width: 24px;
          height: 24px;
          background-color: #ffffff;
          border-radius: 50%;
          flex-shrink: 0;
        }
        .podcasts-highlight {
          display: inline-block;
          background-color: #F73C4A;
          color: #ffffff;
          border-radius: 28px;
          padding: 0 14px;
          position: relative;
          line-height: inherit;
        }
        .podcasts-star-wrapper {
          position: absolute;
          top: -16px;
          right: -14px;
          width: 28px;
          height: 28px;
          pointer-events: none;
        }
        @media (min-width: 768px) {
          .podcasts-star-wrapper {
            top: -22px;
            right: -18px;
            width: 32px;
            height: 32px;
          }
        }
      `}</style>

      <div ref={ref} className={`transition-all duration-700 ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"} mx-auto px-4 sm:px-6 lg:px-8 max-w-5xl`} style={{
      color: "rgb(33, 33, 31)",
      fontFamily: "Switzer, Inter, sans-serif",
      textAlign: "center"
    }}>
        <div className="w-full mx-auto">
          <h1 style={{
          color: "rgb(33, 33, 31)",
          fontFamily: "Switzer, Inter, sans-serif",
          fontSize: "clamp(28px, 4.5vw, 48px)",
          fontWeight: "400",
          lineHeight: "1.15",
          textTransform: "uppercase",
          textAlign: "center",
          margin: "0 0 24px 0"
        }}>
            <span className="podcasts-highlight ![background-image:linear-gradient(90deg,_rgba(1,_139,_185,_1)_0%,_rgba(52,_73,_154,_1)_100%)]">
              PODCASTS
              <span className="podcasts-star-wrapper">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/star_dark.svg" alt="" className="w-full h-auto" />
              </span>
            </span>{" "}
            DE ASAMBLEAS DE DIOS:
            <br />
            HISTORIAS, LIDERAZGO Y FE
          </h1>

          <p style={{
          color: "rgb(33, 33, 31)",
          fontFamily: "Switzer, Inter, sans-serif",
          fontSize: "clamp(16px, 2vw, 20px)",
          fontWeight: "300",
          lineHeight: "1.5",
          textAlign: "center",
          margin: "0 auto 32px auto"
        }} className="max-w-2xl px-2">
            Podcasts para líderes ministeriales y para padres, hay algo más para todos
          </p>

          <div style={{
          display: "flex",
          justifyContent: "center"
        }}>
            <Link to="#" className="podcasts-btn">
              MÁS INFORMACIÓN
              <span className="podcasts-btn-icon">
                <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M2.5 11.5L11.5 2.5M11.5 2.5H5M11.5 2.5V9" stroke="#21211F" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </span>
            </Link>
          </div>
        </div>
      </div>
    </section>;
}